import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Icons from "../../../../../Config/Images";
import { getGlobalGenericNameAPI } from "../../../../../Store/Action/globalAction";
import { UploadMediaRequestAPI } from "../../../../../Store/Action/mediaAction";
import {
  getLoggedInUserDetailsAPI,
  logOutUserAPI,
  updateUserAPI,
} from "../../../../../Store/Action/UserAction";
import { logout } from "../../../../../Store/Slice/authSlice";
import Footer from "../../../Layout/Footer/Footer";
import Header from "../../../Layout/Header/Header";
import EditModal from "../CustomModals/EditModal";
import EditModalAddress from "../CustomModals/EditModalAddress";
import LogoutModal from "../CustomModals/LogoutModal";
import "./ManageProfile.css";
import { getUserDetailsInOnboarding } from "../../../../../Store/Action/onboardingAction";
import { BASE_URL } from "../../../../../Constants/AppConstants";
import { reverseEasing } from "framer-motion";
import { logoutUser } from "../../../../../Store/Slice/UserSlice";
import { resetOnboardingFlag } from "../../../../../Store/Slice/onboardingSlice";
import persistStore from "redux-persist/es/persistStore";
import { store } from "../../../../../Store";

const ManageProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);

  // const [userOnboardingData, setUserOnboardingData] = useState([]);
  const [userOnboardingData, setUserOnboardingData] = useState({
    user_whatsApp_number: "",
    user_office_email_id: "",
    user_shop_name: "",
    user_gst_number: "",
    user_has_gst: "",
  });
  const [loggedInUserData, setLoggedInUserData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [addressType, setAddressType] = useState(""); // Track the type of address
  const [selectedFile, setSelectedFile] = useState(null);
  const [isWastageEnabled, SetIsWastageEnabled] = useState(true);
  const [genericTypeId, setGenericTypeId] = useState();

  const handleOpen = () => {
    setIsModalOpen(true); // Open the modal
  };
  const handleAddressOpen = (addressType) => {
    setAddressType(addressType); // Set the address type (billing/shipping)
    // setIsAddressModalOpen(true); // Open the address modal
  };
  const handleClose = () => {
    setIsModalOpen(false);
    // setIsAddressModalOpen(false);
  };
  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        setLoggedInUserData(result?.data?.[0]);
        // setUserData(result?.data?.[0]);
      })
    );
  }, [dispatch]);

  const userDetails = useSelector((state) => state.auth.user);

  const fetchOnboardingData = () => {
    dispatch(
      getUserDetailsInOnboarding({}, (result) => {
        result?.data?.map((item) => {
          if (item.generic_name === "whatsAppNumber") {
            setUserOnboardingData((prev) => {
              return {
                ...prev,
                user_whatsApp_number:
                  item.user_additional_information_data_value,
              };
            });
          }
          if (item.generic_name === "workEmailAddress") {
            setUserOnboardingData((prev) => {
              return {
                ...prev,
                user_office_email_id:
                  item.user_additional_information_data_value,
              };
            });
          }
          if (item.generic_name === "gstNumber") {
            setUserOnboardingData((prev) => {
              return {
                ...prev,
                user_gst_number: item.user_additional_information_data_value,
              };
            });
          }
          if (item.generic_name === "shopName") {
            setUserOnboardingData((prev) => {
              return {
                ...prev,
                user_shop_name: item.user_additional_information_data_value,
              };
            });
          }
          if (item.generic_name === "gstCheckbox") {
            setUserOnboardingData((prev) => {
              return {
                ...prev,
                user_has_gst: item.user_additional_information_data_value,
              };
            });
          }
        });
      })
    );
  };
  useEffect(() => {
    fetchOnboardingData();
  }, []);
  const handleFileChange = (e) => {
    const files = e.target.files;
    const file = files[0];
    const newImageSrc = URL.createObjectURL(file);
    if (file) {
      setSelectedFile(file);
      handleUpload(file); // Call upload function when file is selected
    }
  };
  const handleUpload = (file) => {
    const driveName = "userProfile";
    const isMultiple = false;   

    dispatch(
      UploadMediaRequestAPI([file], driveName, isMultiple, (result) => {
        const requestData = {
          user_profile_image_id: result?.data?.[0]?.file_storage_id,
        };

        // return
        if (result?.status) {
          dispatch(
            updateUserAPI(requestData, (result2) => {
              if (result2?.status) {
                toast.success(result2?.message?.message);
                dispatch(
                  getLoggedInUserDetailsAPI({}, (result) => {
                    setUserData(result?.data?.[0]);
                    setLoggedInUserData(result?.data?.[0]);
                  })
                );
              }
            })
          );
        } else {
          // toast.error("Failed to upload profile photo.");
        }
      })
    );
  };
  const handleCloseModal = () => {
    setIsLogoutModalOpen(false); // Function to close the modal
  };
  const loggedInUserCall = () => {
    dispatch(getLoggedInUserDetailsAPI({}, (result) => {}));
  };
  const handleLogOut = () => {
    dispatch(
      logOutUserAPI({}, (result) => {
        if (result?.status) {
          dispatch(logout());
          dispatch(logoutUser());
          dispatch(resetOnboardingFlag());
          persistStore(store).purge(); // Clears `persist:root` from local storage
          localStorage.removeItem("persist:root"); // Force remove persisted state
          localStorage.removeItem("userId"); // Force remove user
          localStorage.removeItem("startTime"); // Force remove start timer
          localStorage.removeItem("flagOnboarded"); // Force remove flag onboarded flag
          localStorage.removeItem("isRefillingOnboardingFormIsNowInReviewed");
          localStorage.removeItem("cameFromHomeClick");
          toast.success(result?.data?.message);
          loggedInUserCall();
          setTimeout(() => {
            navigate("/home", { replace: true }); // Ensure navigation happens after API call
          }, 500); // Added delay to ensure function executes
        }
        setIsLogoutModalOpen(false); // Close the modal after logout
      })
    );
  };

  useEffect(() => {
    dispatch(
      getGlobalGenericNameAPI({}, (result) => {
        if (result && Array?.isArray(result)) {
          const userShopNameInfo = result?.find(
            (item) => item?.generic_data_type_name === "wastage"
          );
          setGenericTypeId(userShopNameInfo?.generic_data_type_id || null);
        }
      })
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        SetIsWastageEnabled(
          result?.data?.[0]?.user_generic_data_value[0]
            ?.user_generic_data_boolean_value
        );
      })
    );
  }, [dispatch]);

  return (
    <>
      <Header />
      <div className="manage-profile-div">
        <div className="account-header-manage-profile">
          <p className="ac-header-para">Manage Profile</p>
          <div className="user-profile-div">
            <div className="profile-picture">
              {/* <img src={Icons.profile_picture_image} alt="Profile" /> */}
              <img
                className="user-image"
                // src={`${BASE_URL}${loggedInUserData?.image}`}
                src={
                  loggedInUserData?.image
                    ? `${BASE_URL}${loggedInUserData.image}`
                    : Icons.default_image
                }
                alt="Profile"
                onClick={() => document.getElementById("fileInput").click()} // Open file input on click
              />
              <input
                type="file"
                id="fileInput"
                style={{ display: "none" }}
                accept="image/*"
                onChange={handleFileChange}
              />
              <div className="camera-pic-image-div">
                <img
                  className="camera-pic"
                  src={Icons.camera_profile_image}
                  alt=""
                  onClick={() => document.getElementById("fileInput").click()} // Open file input on click
                />
              </div>
            </div>
            <div className="user-details">
              <p className="user-name-para">{userData?.user_first_name}</p>
              <p className="user-number-para">{userData?.user_mobile_number}</p>
            </div>
            <div className="logout-img-icon-div">
              <img
                onClick={() => setIsLogoutModalOpen(true)} // Open the modal on logout icon click
                src={Icons.logout_img_icon}
                alt=""
              />
            </div>
          </div>
        </div>

        <div className="divider" />

        <div className="user-details-div">
          <div className="user-detail-section">
            <p>Name</p>
            <input
              type="text"
              // placeholder={userData?.user_first_name}
              // placeholder={userData?.user_first_name}
              placeholder={loggedInUserData?.user_first_name}
              readOnly
              style={{ backgroundColor: "#EDF6FF" }}
            />
          </div>
          <div className="user-detail-section">
            <p>Mobile Number</p>
            <input
              type="text"
              // placeholder={userData?.user_mobile_number}
              placeholder={loggedInUserData?.user_mobile_number}
              readOnly
              style={{ backgroundColor: "#EDF6FF" }}
            />
          </div>
          <div className="user-detail-section">
            <p>Whatsapp Number</p>
            <div className="input-with-icon">
              <input
                type="text"
                placeholder={userOnboardingData?.user_whatsApp_number}
                readOnly
              />
              <img
                onClick={handleOpen}
                className="edit-icon-img"
                src={Icons.edit_icon}
                alt=""
              />
            </div>
          </div>
          <div className="user-detail-section">
            <p> Email </p>
            <div className="input-with-icon">
              <input
                type="text"
                placeholder={userOnboardingData?.user_office_email_id}
                readOnly
              />
              <img
                onClick={handleOpen}
                className="edit-icon-img"
                src={Icons.edit_icon}
                alt=""
              />
            </div>
          </div>
          <div className="user-detail-section">
            <p>Shop Name</p>
            <input
              type="text"
              placeholder={userOnboardingData?.user_shop_name}
              readOnly
              style={{ backgroundColor: "#EDF6FF" }}
            />
          </div>
          {userOnboardingData?.user_has_gst?.toLowerCase() !== "no" && (
            <>
              <div className="user-detail-section">
                <p>GST Number</p>
                <input
                  type="text"
                  placeholder={userOnboardingData?.user_gst_number}
                  readOnly
                  style={{ backgroundColor: "#EDF6FF" }}
                />
              </div>
            </>
          )}

          <div className="user-detail-section">
            <p>Role</p>
            <input
              type="text"
              placeholder={loggedInUserData?.user_role_name}
              readOnly
              style={{ backgroundColor: "#EDF6FF" }}
            />
          </div>
        </div>
      </div>
      {/* Include the EditModal */}
      <EditModal
        isOpen={isModalOpen}
        onClose={handleClose} //
        userData={userOnboardingData} // passimg userData
        setUserOnboardingData={setUserOnboardingData}
        // fetchOnboardingData={fetchOnboardingData}
      />

      {/* Modal Component */}
      {isLogoutModalOpen && (
        <LogoutModal onClose={handleCloseModal} onLogOut={handleLogOut} />
      )}
      {/* Footer */}
      <Footer />
    </>
  );
};

export default ManageProfile;
